import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationQiagenData } from './Data';

export interface IntegrationQiagenState extends BaseIntegrationState {
  type: string;
}

export class IntegrationQiagenModel extends BaseIntegration<IntegrationQiagenData, IntegrationQiagenState> {
  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/qiagen/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
